import { Outlet, Link } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import { useRefreshMutation } from './authApiSlice';
import usePersist from '../../hooks/usePersist';
import { useSelector } from 'react-redux';
import { selectCurrentToken } from './authSlice';
import PulseLoader from 'react-spinners/PulseLoader';

const PersistLogin = () => {
  const [persist] = usePersist();
  const token = useSelector(selectCurrentToken);
  const effectRan = useRef(false);

  const [trueSuccess, setTrueSuccess] = useState(false);

  const [refresh, { isUninitialized, isLoading, isSuccess, isError, error }] =
    useRefreshMutation();

  useEffect(() => {
    // only want to run once, but React 18 Strict mode will mount, unmount, and remount again.
    if (effectRan.current === true || process.env.NODE_ENV !== 'development') {
      const verifyRefreshToken = async () => {
        try {
          await refresh();
          setTrueSuccess(true);
        } catch (err) {
          console.error(err);
        }
      };

      if (!token && persist) verifyRefreshToken();
    }
    return () => (effectRan.current = true);
    // eslint-disable-next-line
  }, []);

  let content;
  if (!persist || (isSuccess && trueSuccess) || (token && isUninitialized)) {
    content = <Outlet />;
  } else if (isLoading) {
    content = <PulseLoader color={'#FFF'} />;
  } else if (isError) {
    content = (
      <p className='errmsg'>
        {`${error.data?.message} - `}
        <Link to='/login'>Please login again</Link>
      </p>
    );
  }

  return content;
};

export default PersistLogin;
